export default theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  expansionPanelRoot: {
    '&:first-child': {
      borderTopLeftRadius: 35,
      borderTopRightRadius: 35,
    },
    '&:last-child': {
      borderBottomLeftRadius: 35,
      borderBottomRightRadius: 35,
    },
  },
  expansionPanelExpanded: {
    borderRadius: 35,
  },
  expandPanelSummary: {
    alignItems: 'center',
    display: 'flex',
  },
  expandPanelIcon: {
    color: theme.palette.secondary.main,
    marginRight: '15px',
    width: '60px',
    height: '40px',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    backgroundColor: theme.palette.green,
    color: '#fff',
    borderRadius: 20,
    padding: '3px 16px !important',
    // paddingRight: '0 !important',
    // display: 'inline-block',
    marginRight: '32px',
    whiteSpace: 'nowrap',
  },
  expandPanelDetailsText: {
    paddingRight: '24px',
  },
  // paper: {
  //   maxWidth: '75.5vw',
  //   margin: `${theme.spacing.unit}px auto`,
  //   padding: theme.spacing.unit * 2,
  // },
})
